export enum AuthClient {
  WEB = "WEB",
  ANDROID = "ANDROID",
  IOS = "IOS",
}

/** Portal login always identifies as WEB; Flutter should send ANDROID or IOS. */
export const PORTAL_AUTH_CLIENT = AuthClient.WEB;
